var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"inner"},[_c('Content',[_c('div',{staticClass:"box",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }